import moment from "moment";
let timeStemp = moment()
  .add(543, "years")
  .format("DD/MM/YYYY", true);
Array.prototype.insert = function(index, item) {
  this.splice(index, 0, item);
};

const print_QRcode_cus = async function(data) {
  //let DATA = data;
  // console.log(data);
  // console.log("1");
  let QR_list = [];
  for (let i = 0; i < data.length; i++) {
    //check if the number is even

    QR_list.insert(1, [
      {
        qr: data[i][0].NEWCUSTOMER_ID,
        fit: 60,
        alignment: "right",
        margin: [0, 0, 30, 0], //left top right bottom
      },
      {
        qr: data[i][1].NEWCUSTOMER_ID,
        fit: 60,
        alignment: "right",
        margin: [0, 0, 30, 0], //left top right bottom
      },
      {
        qr: data[i][2].NEWCUSTOMER_ID,
        fit: 60,
        alignment: "right",
        margin: [0, 0, 30, 0], //left top right bottom
      },
    ]);

    QR_list.insert(1, [
      {
        text: data[i][0].CUSTOMER_NAME,
        fontSize: 16,
        bold: true,
        style: `header`,
        margin: [0, 10, 0, 0],
      },
      {
        text: data[i][1].CUSTOMER_NAME,
        fontSize: 16,
        bold: true,
        style: `header`,
        margin: [0, 10, 0, 0],
      },
      {
        text: data[i][2].CUSTOMER_NAME,
        fontSize: 16,
        bold: true,
        style: `header`,
        margin: [0, 10, 0, 0],
      },
    ]);
  }
  // console.log(QR_list);
  let x = [{
    qr: "text in QR",
    fit: 100,
    alignment: "center",
    margin: [0, 0, 0, 0], //left top right bottom
  },
  {
    qr: "text in QR",
    fit: 100,
    alignment: "center",
    margin: [0, 0, 0, 0], //left top right bottom
  },
  {
    qr: "text in QR",
    fit: 100,
    alignment: "center",
    margin: [0, 0, 0, 0], //left top right bottom
  },]
  const pdf = {
    //pageSize: 'A4',
    // pageMargins: [ 30, 0, 30, 0 ],
    footer(currentPage, pageCount) {
      return {
        columns: [
          // { text: "ท้ายกระดาษ", fontSize: 15, alignment: "center" },
          {
            text:
              "หน้าที่ " +
              currentPage.toString() +
              " จาก " +
              pageCount +
              " หน้า",
            margin: [5, 5, 15, 5],
            alignment: "right",
          },
        ],
      };
    },
    // สีพื้นหลัง
    // background: function() {
    //   return {
    //     canvas: [
    //       {
    //         type: "rect",
    //         x: 0,
    //         y: 0,
    //         w: 595.28,
    //         h: 841.89,
    //         color: "#00BFFF",
    //       },
    //     ],
    //   };
    // },
    content: [
      {
        columns: [
          x
        ],
      },
      {
        columns: [
          {
            text: "รายชื่อลูกค้า",
            style: "tableHeader",
            alignment: "center",
            bold: true,
            margin: [0, 10, 0, 10], //left top right bottom
          },
          {
            text: "รายชื่อลูกค้า",
            style: "tableHeader",
            alignment: "center",
            bold: true,
            margin: [0, 10, 0, 10], //left top right bottom
          },
          {
            text: "รายชื่อลูกค้า",
            style: "tableHeader",
            alignment: "center",
            bold: true,
            margin: [0, 10, 0, 10], //left top right bottom
          },
        ],
      },
      // {
      //   table: {
      //     widths: [300, 300, 300],
      //     body: QR_list,
      //   },
      //   margin: [0, 0, 0, 10],
      // },
    ],
    defaultStyle: {
      font: "THSarabunNew",
    },
    styles: {
      header: {
        fontSize: 18,
        alignment: "center",
        //bold: true
      },
      content: {
        fontSize: 16,
        alignment: "left",
        margin: [0, 10, 0, 0],
      },
      content_8: {
        fontSize: 16,
        alignment: "left",
        margin: [20, 10, 0, 0],
      },
      signature: {
        fontSize: 16,
        alignment: "center",
        margin: [0, 30, 0, 0],
      },
    },
  };
  return pdf;
};

// The "callback" argument is called with either true or false
// // depending on whether the image at "url" exists or not.
// function imageExists(url, callback) {
//   var img = new Image();
//   img.onload = function() { callback(true); };
//   img.onerror = function() { callback(false); };
//   img.src = url;
// }

// // Sample usage
// var imageUrl = 'http://www.google.com/images/srpr/nav_logo14.png';
// imageExists(imageUrl, function(exists) {
//   console.log('RESULT: url=' + imageUrl + ', exists=' + exists);
// });

// create function TH time
async function newDates(data) {
  // console.log(data);
  let a = moment(data)
    .add(543, "years")
    .format("DD/MM/YYYY hh:mm:ss", true);
  return a;
}
async function newTime(data) {
  //console.log(data);

  let a = moment(data)
    .add(543, "years")
    .format("DD/MM/YYYY hh:mm:ss", true);

  return a;
}
async function newTimeN(data) {
  let a = moment(data)
    .add(543, "years")
    .format("DD/MM/YYYY hh:mm:ss", true);
  return a;
}
function delimeter(data) {
  let y = parseFloat(data).toFixed(2);
  let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return x;
}
export default print_QRcode_cus;
